import { nFormatter } from "utils/parseNumber";

import ICON from "components/icons/profileIcon.svg";

import "./SubscriberCount.scss";

export const SubscriberCount = (props: {
  count: number;
}): JSX.Element => {
  return (
    <div className="subscribers">
      <img src={ICON} alt="" />
      <span>{nFormatter(props.count)}</span>
    </div>
  );
};
